import styled from 'styled-components'

export const MainContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  flex: 1;

  span {
    text-align: center;
  }
`

export const IconExit = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 64px;
  height: 64px;
  border-radius: 60px;
  background: #f5f6fa;
`
